<nz-card class="integration-apps-card" testId="tenant-integration-apps-card">
  <div class="integration-toolbar" testId="tenant-integration-apps-toolbar">
    <button
      nz-button
      nzType="default"
      type="button"
      class="refresh-button"
      [nzLoading]="loading"
      [disabled]="loading"
      (click)="refreshApps()"
      testId="tenant-integration-apps-refresh-button"
    >
      <i nz-icon nzType="reload" nzTheme="outline"></i>
      {{ 'common.refresh' | i18n }}
    </button>
  </div>

  <ng-container *ngIf="hasApps; else emptyState">
    <section class="integration-group" *ngIf="installedApps.length" testId="tenant-integration-apps-installed-section">
      <div class="integration-group-header" testId="tenant-integration-apps-installed-header">
        <div>
          <h3>{{ 'tenant.detail.integration-apps.installed.title' | i18n }}</h3>
          <p>{{ 'tenant.detail.integration-apps.installed.description' | i18n }}</p>
        </div>
        <span class="integration-group-count" testId="tenant-integration-apps-installed-count">{{ installedApps.length }}</span>
      </div>

      <div class="integration-app-grid" testId="tenant-integration-apps-installed-grid">
        <article
          class="integration-app-item installed"
          *ngFor="let app of installedApps"
          [testId]="'tenant-integration-app-installed-card-' + app.appId"
        >
          <div class="integration-app-head" [testId]="'tenant-integration-app-installed-head-' + app.appId">
            <div>
              <div class="integration-app-name-row" [testId]="'tenant-integration-app-installed-name-row-' + app.appId">
                <h4>{{ app.appName }}</h4>
                <nz-tag class="app-id-tag" [testId]="'tenant-integration-app-installed-id-' + app.appId">{{ app.appId }}</nz-tag>
                <nz-tag
                  class="status-tag"
                  [ngClass]="getInstalledStatusTagClass(app.installation?.status)"
                  [testId]="'tenant-integration-app-installed-status-' + app.appId"
                >
                  {{ getInstallationStatusText(app.installation?.status) }}
                </nz-tag>
              </div>
              <p>{{ app.provider }}</p>
            </div>
            <div class="install-actions" [testId]="'tenant-integration-app-installed-actions-' + app.appId">
              <button
                nz-button
                nzType="default"
                type="button"
                class="action-button"
                (click)="openEventLogModal(app)"
                [disabled]="isOperating(app)"
                [testId]="'tenant-integration-app-event-log-button-' + app.appId"
              >
                {{ 'tenant.detail.integration-apps.action.event-log' | i18n }}
              </button>
              <button
                nz-button
                nzType="default"
                type="button"
                class="action-button action-button-primary"
                (click)="openUpdateModal(app)"
                [disabled]="isOperating(app)"
                [testId]="'tenant-integration-app-update-button-' + app.appId"
              >
                {{ 'tenant.detail.integration-apps.action.update' | i18n }}
              </button>
              <button
                nz-button
                nzType="default"
                type="button"
                class="action-button"
                (click)="rotateInstallSecret(app)"
                [disabled]="isOperating(app)"
                [testId]="'tenant-integration-app-rotate-secret-button-' + app.appId"
              >
                {{ 'tenant.detail.integration-apps.action.rotate-secret' | i18n }}
              </button>
              <button
                nz-button
                nzType="default"
                type="button"
                class="action-button action-button-warning"
                *ngIf="app.installation?.status !== 'Suspended'; else resumeAction"
                (click)="suspendInstall(app)"
                [disabled]="isOperating(app)"
                [testId]="'tenant-integration-app-suspend-button-' + app.appId"
              >
                {{ 'tenant.detail.integration-apps.action.suspend' | i18n }}
              </button>
              <ng-template #resumeAction>
                <button
                  nz-button
                  nzType="default"
                  type="button"
                  class="action-button action-button-success"
                  (click)="resumeInstall(app)"
                  [disabled]="isOperating(app)"
                  [testId]="'tenant-integration-app-resume-button-' + app.appId"
                >
                  {{ 'tenant.detail.integration-apps.action.resume' | i18n }}
                </button>
              </ng-template>
              <button
                nz-button
                nzType="default"
                type="button"
                class="action-button action-button-danger"
                (click)="uninstallInstall(app)"
                [disabled]="isOperating(app)"
                [testId]="'tenant-integration-app-uninstall-button-' + app.appId"
              >
                {{ 'tenant.detail.integration-apps.action.uninstall' | i18n }}
              </button>
            </div>
          </div>

          <dl class="integration-meta-list" [testId]="'tenant-integration-app-installed-meta-' + app.appId">
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.installation-status' | i18n }}</dt>
              <dd>{{ getInstallationStatusText(app.installation?.status) }}</dd>
            </div>
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.app-id' | i18n }}</dt>
              <dd class="secret-field">
                <span class="break-all">{{ app.appId || '-' }}</span>
                <button
                  *ngIf="app.appId"
                  nz-button
                  nzType="text"
                  type="button"
                  class="secret-icon-button"
                  (click)="copyText(app.appId)"
                  [testId]="'tenant-integration-app-app-id-copy-' + app.appId"
                >
                  <i nz-icon nzType="copy" nzTheme="outline"></i>
                </button>
              </dd>
            </div>
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.instance-id' | i18n }}</dt>
              <dd class="secret-field">
                <span class="break-all">{{ getInstanceId(app) || '-' }}</span>
                <button
                  *ngIf="getInstanceId(app)"
                  nz-button
                  nzType="text"
                  type="button"
                  class="secret-icon-button"
                  (click)="copyText(getInstanceId(app))"
                  [testId]="'tenant-integration-app-instance-id-copy-' + app.appId"
                >
                  <i nz-icon nzType="copy" nzTheme="outline"></i>
                </button>
              </dd>
            </div>
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.instance-secret' | i18n }}</dt>
              <dd class="secret-field">
                <span class="break-all">{{ getDisplayInstanceSecret(app) }}</span>
                <button
                  *ngIf="getInstanceSecret(app)"
                  nz-button
                  nzType="text"
                  type="button"
                  class="secret-icon-button"
                  (click)="toggleInstanceSecretVisibility(getInstanceId(app))"
                  [testId]="'tenant-integration-app-instance-secret-toggle-' + app.appId"
                >
                  <i nz-icon [nzType]="isInstanceSecretVisible(getInstanceId(app)) ? 'eye-invisible' : 'eye'" nzTheme="outline"></i>
                </button>
                <button
                  *ngIf="getInstanceSecret(app)"
                  nz-button
                  nzType="text"
                  type="button"
                  class="secret-icon-button"
                  (click)="copyText(getInstanceSecret(app))"
                  [testId]="'tenant-integration-app-instance-secret-copy-' + app.appId"
                >
                  <i nz-icon nzType="copy" nzTheme="outline"></i>
                </button>
              </dd>
            </div>
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.external-tenant-id' | i18n }}</dt>
              <dd>{{ app.installation?.externalTenantId || '-' }}</dd>
            </div>
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.webhook-url' | i18n }}</dt>
              <dd class="break-all">{{ app.installation?.webhookUrl || '-' }}</dd>
            </div>
          </dl>
        </article>
      </div>
    </section>

    <section class="integration-group" *ngIf="uninstalledApps.length" testId="tenant-integration-apps-available-section">
      <div class="integration-group-header" testId="tenant-integration-apps-available-header">
        <div>
          <h3>{{ 'tenant.detail.integration-apps.available.title' | i18n }}</h3>
          <p>{{ 'tenant.detail.integration-apps.available.description' | i18n }}</p>
        </div>
        <span class="integration-group-count" testId="tenant-integration-apps-available-count">{{ uninstalledApps.length }}</span>
      </div>

      <div class="integration-app-grid" testId="tenant-integration-apps-available-grid">
        <article
          class="integration-app-item"
          *ngFor="let app of uninstalledApps"
          [testId]="'tenant-integration-app-available-card-' + app.appId"
        >
          <div class="integration-app-head" [testId]="'tenant-integration-app-available-head-' + app.appId">
            <div>
              <div class="integration-app-name-row" [testId]="'tenant-integration-app-available-name-row-' + app.appId">
                <h4>{{ app.appName }}</h4>
                <nz-tag class="app-id-tag" [testId]="'tenant-integration-app-available-id-' + app.appId">{{ app.appId }}</nz-tag>
                <nz-tag class="status-tag status-tag-pending" [testId]="'tenant-integration-app-available-status-' + app.appId">{{
                  'tenant.detail.integration-apps.status.uninstalled' | i18n
                }}</nz-tag>
              </div>
              <p>{{ app.provider }}</p>
            </div>

            <button
              nz-button
              nzType="primary"
              type="button"
              class="install-button"
              (click)="openInstall(app)"
              [disabled]="isOperating(app)"
              *ngIf="app.installUrl"
              [testId]="'tenant-integration-app-open-install-button-' + app.appId"
            >
              {{ 'tenant.detail.integration-apps.open-app' | i18n: { appName: app.appName } }}
            </button>
          </div>

          <dl class="integration-meta-list" [testId]="'tenant-integration-app-available-meta-' + app.appId">
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.install-url' | i18n }}</dt>
              <dd class="break-all">{{ app.displayInstallUrl || '-' }}</dd>
            </div>
            <div>
              <dt>{{ 'tenant.detail.integration-apps.field.supported-events' | i18n }}</dt>
              <dd>{{ app.supportedEvents.join(', ') || '-' }}</dd>
            </div>
          </dl>
        </article>
      </div>
    </section>
  </ng-container>

  <ng-template #emptyState>
    <div class="integration-empty-state" testId="tenant-integration-apps-empty-state">
      <div class="integration-empty-icon" testId="tenant-integration-apps-empty-icon">
        <i nz-icon nzType="api" nzTheme="outline"></i>
      </div>

      <div class="integration-empty-copy" testId="tenant-integration-apps-empty-copy">
        <h3>{{ 'tenant.detail.integration-apps.empty.title' | i18n }}</h3>
        <p>{{ emptyDescription }}</p>
      </div>
    </div>
  </ng-template>
</nz-card>

<nz-modal
  [(nzVisible)]="eventLogModalVisible"
  nzClassName="integration-event-log-modal"
  [nzWidth]="760"
  [nzTitle]="'tenant.detail.integration-apps.event-log.title' | i18n"
  [nzFooter]="null"
  (nzOnCancel)="closeEventLogModal()"
  [testId]="'integration-event-log-modal'"
>
  <ng-container *nzModalContent>
    <div class="event-log-context" *ngIf="eventLogTargetApp">
      <div class="event-log-context-main">
        <span class="event-log-context-icon" aria-hidden="true"><i nz-icon nzType="api" nzTheme="outline"></i></span>
        <div>
          <strong>{{ eventLogTargetApp.appName }}</strong>
          <span>{{ eventLogTargetApp.provider }}</span>
        </div>
      </div>
      <code class="event-log-context-id">{{ eventLogTargetApp.installation?.instanceId || eventLogTargetApp.installation?.integrationId }}</code>
    </div>

    <div class="event-log-skeleton-list" *ngIf="eventLogLoading" testId="tenant-integration-app-event-log-loading">
      <div class="event-log-skeleton-item" *ngFor="let item of [1, 2]"
        ><span></span><div><span></span><span></span></div><b></b
      ></div>
    </div>
    <ng-container *ngIf="!eventLogLoading">
      <ng-container *ngIf="eventLogs.length; else eventLogEmptyState">
        <div class="event-log-list" testId="tenant-integration-app-event-log-list">
          <article class="event-log-item" *ngFor="let eventLog of eventLogs">
            <span class="event-log-item-icon" aria-hidden="true"><i nz-icon nzType="file-text" nzTheme="outline"></i></span>
            <div class="event-log-item-content">
              <div class="event-log-item-heading">
                <div class="event-log-item-title">
                  <strong>{{ eventLog.eventType }}</strong>
                  <span class="event-log-item-description" *ngIf="getEventTypeDescription(eventLog.eventType) as eventDescription">
                    {{ eventDescription }}
                  </span>
                </div>
                <nz-tag class="event-log-status" [nzColor]="eventLog.published ? 'success' : 'error'">
                  {{ getEventPublishStatusText(eventLog.published) }}
                </nz-tag>
              </div>
              <span class="event-log-item-time"
                ><i nz-icon nzType="clock-circle" nzTheme="outline"></i>{{ formatEventOccurredAt(eventLog.occurredAt) }}</span
              >
            </div>
          </article>
        </div>
      </ng-container>
      <ng-template #eventLogEmptyState>
        <div class="event-log-empty" testId="tenant-integration-app-event-log-empty">
          <span class="event-log-empty-icon" aria-hidden="true"><i nz-icon nzType="file-search" nzTheme="outline"></i></span>
          <div>
            <strong>{{ 'tenant.detail.integration-apps.event-log.empty' | i18n }}</strong>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <div class="event-log-footer">
      <span class="event-log-footer-total">{{
        'tenant.detail.integration-apps.event-log.total' | i18n: { count: eventLogTotalCount }
      }}</span>
      <div class="event-log-pagination">
        <button
          nz-button
          nzSize="small"
          type="button"
          (click)="loadEventLogs(eventLogPageIndex - 1)"
          [disabled]="eventLogLoading || eventLogPageIndex === 0"
          [testId]="'integration-event-log-previous-page-button'"
        >
          <i nz-icon nzType="left" nzTheme="outline"></i>
          {{ 'tenant.detail.integration-apps.event-log.previous-page' | i18n }}
        </button>
        <button
          nz-button
          nzSize="small"
          type="button"
          (click)="loadEventLogs(eventLogPageIndex + 1)"
          [disabled]="eventLogLoading || !eventLogHasNextPage"
          [testId]="'integration-event-log-next-page-button'"
        >
          {{ 'tenant.detail.integration-apps.event-log.next-page' | i18n }}
          <i nz-icon nzType="right" nzTheme="outline"></i>
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="updateModalVisible"
  nzClassName="integration-update-modal"
  [nzWidth]="780"
  [nzTitle]="'tenant.detail.integration-apps.update.title' | i18n"
  [nzOkText]="'common.save' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  (nzOnCancel)="closeUpdateModal()"
  (nzOnOk)="submitUpdate()"
  testId="tenant-integration-apps-update-modal"
>
  <ng-container *nzModalContent>
    <form [formGroup]="updateForm" nz-form class="integration-update-form" testId="tenant-integration-apps-update-form">
      <nz-form-item class="integration-form-item">
        <nz-form-label [nzSpan]="24">{{ 'tenant.detail.integration-apps.field.webhook-url' | i18n }}</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input formControlName="webhookUrl" testId="tenant-integration-apps-update-webhook-input" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="integration-form-item">
        <nz-form-label [nzSpan]="24">{{ 'tenant.detail.integration-apps.field.supported-events' | i18n }}</nz-form-label>
        <nz-form-control [nzSpan]="24" [nzValidateStatus]="updateForm.controls.subscribedEvents">
          <div class="supported-events-panel" testId="tenant-integration-apps-supported-events-panel">
            <div class="supported-events-section" testId="tenant-integration-apps-recommended-events-section">
              <div class="supported-events-section-title">{{ 'official.third-party-app.form.supported-events-recommended' | i18n }}</div>
              <div class="supported-events-recommended-grid" testId="tenant-integration-apps-recommended-events-grid">
                <label
                  nz-checkbox
                  *ngFor="let pattern of supportedEventOptions"
                  [nzChecked]="isRecommendedSubscribedEventSelected(pattern)"
                  (nzCheckedChange)="toggleRecommendedSubscribedEvent(pattern, $event)"
                  class="supported-event-option"
                  [testId]="'tenant-integration-apps-recommended-event-' + pattern"
                >
                  <span class="supported-event-option-copy">
                    <span class="supported-event-option-title">{{ getSupportedEventLabel(pattern) }}</span>
                    <span class="supported-event-option-text">{{ pattern }}</span>
                  </span>
                </label>
              </div>
            </div>

            <div class="supported-events-section" testId="tenant-integration-apps-selected-events-section">
              <div class="supported-events-section-title">{{ 'official.third-party-app.form.supported-events-selected' | i18n }}</div>
              <div
                class="supported-events-selected-empty"
                *ngIf="!selectedSubscribedEvents.length"
                testId="tenant-integration-apps-selected-events-empty"
              >
                {{ 'official.third-party-app.form.supported-events-empty' | i18n }}
              </div>
              <div
                class="supported-events-tags"
                *ngIf="selectedSubscribedEvents.length"
                testId="tenant-integration-apps-selected-events-tags"
              >
                <nz-tag
                  *ngFor="let event of selectedSubscribedEvents"
                  nzMode="closeable"
                  (nzOnClose)="removeSubscribedEvent(event)"
                  [testId]="'tenant-integration-apps-selected-event-' + event"
                >
                  {{ event }}
                </nz-tag>
              </div>
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
